import { z } from "zod";
import { OrgchartType } from "./FilterBar.models";

export const FilterBarSchema = z.object({
  autocomplete: z
    .literal("")
    .or(
      z.object({
        id: z.string(),
        label: z.string(),
        initials: z.string(),
        position: z.string().optional().nullable(),
        avatar: z.string().nullable(),
      })
    )
    .or(z.object({ areaId: z.string(), name: z.string() }))
    .or(z.null()),
  orgChartType: z.enum(OrgchartType),
});
